var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("van-nav-bar", {
        attrs: {
          "safe-area-inset-top": "",
          "left-arrow": "",
          title: "历史记录",
          fixed: "",
        },
        on: { "click-left": _vm.onClickLeft },
      }),
      _c(
        "van-row",
        { staticClass: "search-input", attrs: { "safe-area-inset-top": "" } },
        [
          _c(
            "van-col",
            { attrs: { span: "24" } },
            [
              _c(
                "van-tabs",
                {
                  attrs: {
                    color: "#1989fa",
                    "title-inactive-color": "rgb(188, 188, 188)",
                    "title-active-color": "#1989fa",
                  },
                  on: { change: _vm.onClickTab },
                  model: {
                    value: _vm.activeName,
                    callback: function ($$v) {
                      _vm.activeName = $$v
                    },
                    expression: "activeName",
                  },
                },
                [
                  _c(
                    "van-tab",
                    {
                      attrs: { title: "配方浏览记录", name: "browsingHistory" },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "search-dev" },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.historyFinished,
                                "finished-text": "没有更多了",
                              },
                              model: {
                                value: _vm.historyLoading,
                                callback: function ($$v) {
                                  _vm.historyLoading = $$v
                                },
                                expression: "historyLoading",
                              },
                            },
                            _vm._l(
                              _vm.browsingHistoryList,
                              function (item, index) {
                                return _c(
                                  "div",
                                  {
                                    key: index,
                                    staticClass: "order-box",
                                    on: {
                                      click: function ($event) {
                                        return _vm.orderClick(item)
                                      },
                                    },
                                  },
                                  [
                                    _c("div", { staticClass: "div-box-txt" }, [
                                      _c("div", { staticClass: "d1" }, [
                                        _c("div", {
                                          staticClass: "d1-title1",
                                          style:
                                            item.colorSpecial != 10071004
                                              ? "background-color:" +
                                                item.colorRgb +
                                                ";background-image: linear-gradient(" +
                                                item.gcColorRgb +
                                                "," +
                                                item.colorRgb +
                                                "," +
                                                item.colorRgb +
                                                "," +
                                                item.gcColorRgb +
                                                ")"
                                              : "background-color:" +
                                                item.colorRgb,
                                        }),
                                        _c(
                                          "div",
                                          { staticClass: "d1-title2" },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "d1-title1-txt1" },
                                              [
                                                _c(
                                                  "van-row",
                                                  { attrs: { justify: "end" } },
                                                  [
                                                    _c("van-col", {
                                                      staticClass: "env-col",
                                                    }),
                                                    _c(
                                                      "van-col",
                                                      { attrs: { span: "15" } },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "txt-span",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.colorCode
                                                              ) +
                                                                " " +
                                                                _vm._s(
                                                                  item.colorName
                                                                )
                                                            ),
                                                          ]
                                                        ),
                                                        item.collectionTime ==
                                                        null
                                                          ? _c("van-icon", {
                                                              attrs: {
                                                                size: "1.2rem",
                                                                color:
                                                                  "rgb(204,204,204)",
                                                                name: "star",
                                                              },
                                                            })
                                                          : _c("van-icon", {
                                                              attrs: {
                                                                size: "1.2rem",
                                                                color:
                                                                  "rgb(254,200,9)",
                                                                name: "star",
                                                              },
                                                            }),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "van-col",
                                                      {
                                                        staticStyle: {
                                                          blackgroun: "red",
                                                        },
                                                        attrs: { span: "8" },
                                                      },
                                                      [
                                                        item.paintBrandCode ===
                                                          "NBW" ||
                                                        item.paintBrandCode ===
                                                          "NBS1K" ||
                                                        item.paintBrandCode ===
                                                          "NBS2K"
                                                          ? _c("img", {
                                                              staticClass:
                                                                "img-log",
                                                              attrs: {
                                                                src: require("../../assets/image/brand2.png"),
                                                                alt: "",
                                                              },
                                                            })
                                                          : _c("img", {
                                                              staticClass:
                                                                "img-log",
                                                              attrs: {
                                                                src: require("../../assets/image/brand1.png"),
                                                                alt: "",
                                                              },
                                                            }),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "van-row",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "2px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "van-col",
                                                      { attrs: { span: "24" } },
                                                      [
                                                        item.avgScore > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "10px",
                                                                },
                                                              },
                                                              [
                                                                _vm._l(
                                                                  _vm
                                                                    .historyCommentLevelImg[
                                                                    index
                                                                  ],
                                                                  function (
                                                                    item,
                                                                    index
                                                                  ) {
                                                                    return _c(
                                                                      "img",
                                                                      {
                                                                        key: index,
                                                                        staticClass:
                                                                          "img-styles",
                                                                        attrs: {
                                                                          src: item.url,
                                                                          alt: "",
                                                                        },
                                                                      }
                                                                    )
                                                                  }
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        margin:
                                                                          "1px 0 0 8px",
                                                                        "font-size":
                                                                          "13px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.avgScore
                                                                      ) + "分"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              2
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "margin-left":
                                                                    "10px",
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        margin:
                                                                          "1px 0 0",
                                                                        "font-size":
                                                                          "13px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "暂无评分"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _c(
                                                  "div",
                                                  { staticClass: "div-end" },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "div-end-d1",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "icon-circle",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon-circle-class",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.recipeLabel
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "icon-circleTwo",
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "icon-circle-class",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.paintBrandLabel
                                                                  )
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        item.collectionCount > 0
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-circleThree",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon-circle-class",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.collectionCount
                                                                      ) +
                                                                        "次收藏"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "div-end-d2",
                                                      },
                                                      [
                                                        item.photo === null ||
                                                        item.photo === ""
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-imgs-style",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "13px",
                                                                        color:
                                                                          "rgb(0,145,220)",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "暂无图片"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-imgs-style",
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.imgClick(
                                                                        item
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _c("van-icon", {
                                                                  attrs: {
                                                                    name: "photo-o",
                                                                  },
                                                                }),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "font-size":
                                                                          "13px",
                                                                        color:
                                                                          "rgb(0,145,220)",
                                                                        padding:
                                                                          "0px 3px",
                                                                      },
                                                                    attrs: {
                                                                      color:
                                                                        "rgb(0,145,220)",
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      " 预览 "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c("div", {
                                                                  attrs: {
                                                                    id: "triangle-right",
                                                                  },
                                                                }),
                                                              ],
                                                              1
                                                            ),
                                                      ]
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ]
                                        ),
                                      ]),
                                      _c(
                                        "div",
                                        { staticClass: "d2" },
                                        [
                                          _c(
                                            "van-row",
                                            { staticClass: "van-rows" },
                                            [
                                              _c("van-col", {
                                                staticClass: "env-col",
                                                attrs: { span: "2" },
                                              }),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "20" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "span-h3-box",
                                                    },
                                                    [
                                                      _c("img", {
                                                        staticStyle: {
                                                          height: "1.3rem",
                                                          position: "relative",
                                                          top: "3px",
                                                        },
                                                        attrs: {
                                                          src: require("../../assets/image/vehicleIcon.png"),
                                                          alt: "",
                                                        },
                                                      }),
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-h3",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.carBrandName
                                                            ) +
                                                              " - " +
                                                              _vm._s(
                                                                item.carModelName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "van-row",
                                            { staticClass: "van-rows" },
                                            [
                                              _c("van-col", {
                                                staticClass: "env-col",
                                                attrs: { span: "2" },
                                              }),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("上传时间")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "8" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.uploadTimeStr
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("上传地域 ")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "span-colorOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.uploadRegionName
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "van-row",
                                            { staticClass: "van-rows" },
                                            [
                                              _c("van-col", {
                                                staticClass: "env-col",
                                                attrs: { span: "2" },
                                              }),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("适用车龄")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "8" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "span-colorOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.carAgeDesc)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("车型年款")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "span-colorOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(item.recipeYear)
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "van-row",
                                            { staticClass: "van-rows" },
                                            [
                                              _c("van-col", {
                                                staticClass: "env-col",
                                                attrs: { span: "2" },
                                              }),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("调漆工序")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "8" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "span-colorOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.isThree == 1
                                                            ? "多工序"
                                                            : "单工序"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    { staticClass: "span-min" },
                                                    [_vm._v("偏差描述")]
                                                  ),
                                                ]
                                              ),
                                              _c(
                                                "van-col",
                                                { attrs: { span: "4" } },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "span-colorOne",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.deviantColor
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                                  ]
                                )
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                  _c(
                    "van-tab",
                    { attrs: { title: "我的评论", name: "myComment" } },
                    [
                      _c(
                        "div",
                        { staticClass: "search-dev" },
                        [
                          _c(
                            "van-list",
                            {
                              attrs: {
                                finished: _vm.finished,
                                "finished-text": "没有更多了",
                              },
                              on: { load: _vm.onLoad },
                              model: {
                                value: _vm.loading,
                                callback: function ($$v) {
                                  _vm.loading = $$v
                                },
                                expression: "loading",
                              },
                            },
                            _vm._l(
                              _vm.recipeOrder.list,
                              function (item, index) {
                                return _c("div", { key: index }, [
                                  _c(
                                    "div",
                                    [
                                      _c(
                                        "van-row",
                                        {
                                          staticStyle: {
                                            "margin-top": "10px",
                                            width: "90%",
                                            "margin-left": "5%",
                                          },
                                        },
                                        [
                                          _c(
                                            "van-col",
                                            { attrs: { span: "14" } },
                                            [
                                              item.commentDetailsLevel > 0
                                                ? _c(
                                                    "div",
                                                    _vm._l(
                                                      item.userImgUrlArrs,
                                                      function (item, index) {
                                                        return _c("img", {
                                                          key: index,
                                                          staticClass:
                                                            "img-styles",
                                                          attrs: {
                                                            src: item.url,
                                                            alt: "",
                                                          },
                                                        })
                                                      }
                                                    ),
                                                    0
                                                  )
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "van-col",
                                            {
                                              attrs: {
                                                span: "10",
                                                align: "right",
                                              },
                                            },
                                            [
                                              _c("div", [
                                                _c(
                                                  "span",
                                                  {
                                                    staticStyle: {
                                                      margin: "1px 0 0",
                                                      "font-size": "13px",
                                                      color: "#0092FF",
                                                    },
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.commentTime.substring(
                                                          0,
                                                          10
                                                        )
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      item.commentInfo
                                        ? _c(
                                            "van-row",
                                            {
                                              staticStyle: {
                                                "margin-top": "10px",
                                                width: "90%",
                                                "margin-left": "5%",
                                              },
                                            },
                                            [
                                              _c(
                                                "van-col",
                                                { attrs: { span: "24" } },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "span-h3-box",
                                                    },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticStyle: {
                                                            "font-size": "15px",
                                                          },
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.commentInfo
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              ),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    {
                                      staticClass: "order-box",
                                      on: {
                                        click: function ($event) {
                                          return _vm.orderClick(item)
                                        },
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "div-box-txt" },
                                        [
                                          _c("div", { staticClass: "d1" }, [
                                            _c("div", {
                                              staticClass: "d1-title1",
                                              style:
                                                item.colorSpecial != 10071004
                                                  ? "background-color:" +
                                                    item.colorRgb +
                                                    ";background-image: linear-gradient(" +
                                                    item.gcColorRgb +
                                                    "," +
                                                    item.colorRgb +
                                                    "," +
                                                    item.colorRgb +
                                                    "," +
                                                    item.gcColorRgb +
                                                    ")"
                                                  : "background-color:" +
                                                    item.colorRgb,
                                            }),
                                            _c(
                                              "div",
                                              { staticClass: "d1-title2" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "d1-title1-txt1",
                                                  },
                                                  [
                                                    _c(
                                                      "van-row",
                                                      {
                                                        attrs: {
                                                          justify: "end",
                                                        },
                                                      },
                                                      [
                                                        _c("van-col", {
                                                          staticClass:
                                                            "env-col",
                                                        }),
                                                        _c(
                                                          "van-col",
                                                          {
                                                            attrs: {
                                                              span: "15",
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "txt-span",
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    item.colorCode
                                                                  ) +
                                                                    " " +
                                                                    _vm._s(
                                                                      item.colorName
                                                                    )
                                                                ),
                                                              ]
                                                            ),
                                                            item.collectionTime ==
                                                            null
                                                              ? _c("van-icon", {
                                                                  attrs: {
                                                                    size: "1.2rem",
                                                                    color:
                                                                      "rgb(204,204,204)",
                                                                    name: "star",
                                                                  },
                                                                })
                                                              : _c("van-icon", {
                                                                  attrs: {
                                                                    size: "1.2rem",
                                                                    color:
                                                                      "rgb(254,200,9)",
                                                                    name: "star",
                                                                  },
                                                                }),
                                                          ],
                                                          1
                                                        ),
                                                        _c(
                                                          "van-col",
                                                          {
                                                            staticStyle: {
                                                              blackgroun: "red",
                                                            },
                                                            attrs: {
                                                              span: "8",
                                                            },
                                                          },
                                                          [
                                                            item.paintBrandCode ===
                                                              "NBW" ||
                                                            item.paintBrandCode ===
                                                              "NBS1K" ||
                                                            item.paintBrandCode ===
                                                              "NBS2K"
                                                              ? _c("img", {
                                                                  staticClass:
                                                                    "img-log",
                                                                  attrs: {
                                                                    src: require("../../assets/image/brand2.png"),
                                                                    alt: "",
                                                                  },
                                                                })
                                                              : _c("img", {
                                                                  staticClass:
                                                                    "img-log",
                                                                  attrs: {
                                                                    src: require("../../assets/image/brand1.png"),
                                                                    alt: "",
                                                                  },
                                                                }),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "van-row",
                                                      {
                                                        staticStyle: {
                                                          "margin-top": "2px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "van-col",
                                                          {
                                                            attrs: {
                                                              span: "24",
                                                            },
                                                          },
                                                          [
                                                            item.avgScore > 0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "10px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _vm._l(
                                                                      _vm
                                                                        .commentLevelImg[
                                                                        index
                                                                      ],
                                                                      function (
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "img",
                                                                          {
                                                                            key: index,
                                                                            staticClass:
                                                                              "img-styles",
                                                                            attrs:
                                                                              {
                                                                                src: item.url,
                                                                                alt: "",
                                                                              },
                                                                          }
                                                                        )
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            margin:
                                                                              "1px 0 0 8px",
                                                                            "font-size":
                                                                              "13px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.avgScore
                                                                          ) +
                                                                            "分"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ],
                                                                  2
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticStyle:
                                                                      {
                                                                        "margin-left":
                                                                          "10px",
                                                                      },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            margin:
                                                                              "1px 0 0",
                                                                            "font-size":
                                                                              "13px",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "暂无评分"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                          ]
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "div-end",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "div-end-d1",
                                                          },
                                                          [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-circle",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon-circle-class",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.recipeLabel
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "icon-circleTwo",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "icon-circle-class",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.paintBrandLabel
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            item.collectionCount >
                                                            0
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "icon-circleThree",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticClass:
                                                                          "icon-circle-class",
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.collectionCount
                                                                          ) +
                                                                            "次收藏"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _vm._e(),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "div-end-d2",
                                                          },
                                                          [
                                                            item.photo ===
                                                              null ||
                                                            item.photo === ""
                                                              ? _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "icon-imgs-style",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "13px",
                                                                            color:
                                                                              "rgb(0,145,220)",
                                                                          },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          "暂无图片"
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "div",
                                                                  {
                                                                    staticClass:
                                                                      "icon-imgs-style",
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          $event.stopPropagation()
                                                                          return _vm.imgClick(
                                                                            item
                                                                          )
                                                                        },
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "van-icon",
                                                                      {
                                                                        attrs: {
                                                                          name: "photo-o",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "span",
                                                                      {
                                                                        staticStyle:
                                                                          {
                                                                            "font-size":
                                                                              "13px",
                                                                            color:
                                                                              "rgb(0,145,220)",
                                                                            padding:
                                                                              "0px 3px",
                                                                          },
                                                                        attrs: {
                                                                          color:
                                                                            "rgb(0,145,220)",
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          " 预览 "
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c("div", {
                                                                      attrs: {
                                                                        id: "triangle-right",
                                                                      },
                                                                    }),
                                                                  ],
                                                                  1
                                                                ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _c(
                                            "div",
                                            { staticClass: "d2" },
                                            [
                                              _c(
                                                "van-row",
                                                { staticClass: "van-rows" },
                                                [
                                                  _c("van-col", {
                                                    staticClass: "env-col",
                                                    attrs: { span: "2" },
                                                  }),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "20" } },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "span-h3-box",
                                                        },
                                                        [
                                                          _c("img", {
                                                            staticStyle: {
                                                              height: "1.3rem",
                                                              position:
                                                                "relative",
                                                              top: "3px",
                                                            },
                                                            attrs: {
                                                              src: require("../../assets/image/vehicleIcon.png"),
                                                              alt: "",
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-h3",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.carBrandName
                                                                ) +
                                                                  " - " +
                                                                  _vm._s(
                                                                    item.carModelName
                                                                  )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "van-row",
                                                { staticClass: "van-rows" },
                                                [
                                                  _c("van-col", {
                                                    staticClass: "env-col",
                                                    attrs: { span: "2" },
                                                  }),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("上传时间")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.uploadTimeStr
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("上传地域 ")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      item.uploadRegionName ===
                                                      ""
                                                        ? _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-colorOne",
                                                            },
                                                            [_vm._v("通用")]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-colorOne",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.uploadRegionName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "van-row",
                                                { staticClass: "van-rows" },
                                                [
                                                  _c("van-col", {
                                                    staticClass: "env-col",
                                                    attrs: { span: "2" },
                                                  }),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("适用车龄")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-colorOne",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.carAgeDesc
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("车型年款")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-colorOne",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.recipeYear
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "van-row",
                                                { staticClass: "van-rows" },
                                                [
                                                  _c("van-col", {
                                                    staticClass: "env-col",
                                                    attrs: { span: "2" },
                                                  }),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("调漆工序")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "8" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-colorOne",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.isThree == 1
                                                                ? "多工序"
                                                                : "单工序"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-min",
                                                        },
                                                        [_vm._v("偏差描述")]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "van-col",
                                                    { attrs: { span: "4" } },
                                                    [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-colorOne",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              item.deviantColor
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _c("div", {
                                    staticStyle: {
                                      "margin-top": "20px",
                                      "margin-bottom": "5px",
                                      "background-color": "white",
                                      height: "5px",
                                      width: "100%",
                                    },
                                  }),
                                ])
                              }
                            ),
                            0
                          ),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("van-number-keyboard", { attrs: { "safe-area-inset-bottom": "" } }),
      _c("van-image-preview", {
        attrs: { images: _vm.images },
        model: {
          value: _vm.showImg,
          callback: function ($$v) {
            _vm.showImg = $$v
          },
          expression: "showImg",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }